import { Chip } from '@mui/material';

// Small count pill; the active state uses a light primary tint rather than a solid fill.
export function CountChip({ count, active = true }: { count: number; active?: boolean }) {
  return (
    <Chip
      size="small"
      label={count}
      sx={[
        { height: 20, cursor: 'inherit', fontWeight: 'fontWeightMedium' },
        active && {
          bgcolor: (theme) => theme.lighten(theme.palette.primary.main, 0.85),
          color: 'primary.dark',
        },
      ]}
    />
  );
}
